import { CheckCircleIcon, ClockIcon, ExclamationCircleIcon } from '@heroicons/react/24/solid'
import { TaxData, taxVerificationStatusEnum as taxVerificationStatus } from '@jobilla/nexus-sdk'
import { useTranslation } from 'react-i18next'

type DisplayTaxDetailsProps = {
	tax?: TaxData
}

export function DisplayTaxDetails({ tax }: DisplayTaxDetailsProps) {
	const { t } = useTranslation('common')

	if (!tax) {
		return <>{t('billing.tax.notRegistered')}</>
	}

	return (
		<div className="ml-2">
			<div>
				<span className="font-medium text-gray-700">{t('billing.tax.id')}</span>
				<span className="ml-2 text-gray-600">
					{!tax.registered ? <>{t('billing.tax.notRegistered')}</> : (
						<>
							{tax.data?.value}
							<>
								{tax.data?.verification == taxVerificationStatus.verified && (
									<CheckCircleIcon
										className="inline ml-2 mt-0 w-5 h-5 text-green-600 flex-shrink-0"
										title={t('billing.tax.verified')}
									/>
								)}
								{tax.data?.verification == taxVerificationStatus.pending && (
									<ClockIcon
										className="inline ml-2 mt-0 w-5 h-5 text-grey-600 flex-shrink-0"
										title={t('billing.tax.pending')}
									/>
								)}
								{tax.data?.verification == taxVerificationStatus.unavailable && (
									<ExclamationCircleIcon
										className="inline ml-2 mt-0 w-5 h-5 text-yellow-600 flex-shrink-0"
										title={t('billing.tax.unavailable')}
									/>
								)}
								{tax.data?.verification == taxVerificationStatus.unverified && (
									<ExclamationCircleIcon
										className="inline ml-2 mt-0 w-5 h-5 text-red-600 flex-shrink-0"
										title={t('billing.tax.unverified')}
									/>
								)}
							</>
						</>
					)}
				</span>
			</div>
			<div>
				<span className="font-medium text-gray-700">{t('billing.tax.rate')}</span>
				<span className="ml-2 text-gray-600">
					{tax.taxRate.percentage}% ({tax.taxRate.displayName})
				</span>
			</div>

			{tax.showWarning
				? (
					<>
						<div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm mt-2">
							<div className="font-medium text-amber-900 mb-1">
								{t('billing.tax.confirmRegistration')}
							</div>
							<div className="text-amber-700">
								{t('billing.tax.confirmRegistrationDesc')}
							</div>
						</div>
					</>
				)
				: null}

			{tax.preventPurchase
				? (
					<>
						<div className="bg-red-50 border border-red-200 rounded-lg p-3 text-sm mt-2">
							<div className="font-medium text-red-900 mb-1">
								{t('billing.tax.unverifiedTitle')}
							</div>
							<div className="text-red-700">
								{t('billing.tax.unverifiedDesc')}
							</div>
						</div>
					</>
				)
				: null}
		</div>
	)
}
